import { createContext } from 'react';
import { useChatModal } from './useChatModal';

export type ChatModalContextValue = ReturnType<typeof useChatModalValue>;

export const chatModalContext = createContext<ChatModalContextValue>({} as never);

export function useChatModalValue() {
  const chatModal = useChatModal();
  const value = useMemo(
    () => ({
      chatModal,
    }),
    [chatModal]
  );

  return value;
}

export function useChatModalContext() {
  return useContext(chatModalContext);
}
